import { render, staticRenderFns } from "./CreateVenue.vue?vue&type=template&id=4a96bf51&scoped=true"
import script from "./CreateVenue.vue?vue&type=script&lang=js"
export * from "./CreateVenue.vue?vue&type=script&lang=js"
import style0 from "./CreateVenue.vue?vue&type=style&index=0&id=4a96bf51&prod&lang=css"
import style1 from "./CreateVenue.vue?vue&type=style&index=1&id=4a96bf51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a96bf51",
  null
  
)

export default component.exports